<template>
  <div class="loading">
    <van-loading type="spinner" vertical />
  </div>
</template>
<script>
export default {
  name: "LOADING",
  data() {
    return {};
  },
};
</script>
<style  scoped>
.loading {
  position: fixed;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Loading.vue